export const vi = {
  translation: {
    nav: {
      title: 'Zen Life Châm Cứu', // Translate this tex
      home: 'Trang Chủ',
      services: 'Dịch Vụ',
      about: 'Giới Thiệu',
      contact: 'Liên Hệ',
      gallery: 'Thư Viện',
      appointment: 'Cuộc hẹn',
      herbtea: "Trà thảo mộc",
      telemedicine: 'Y Tế Từ Xa',
      store: 'Cửa Hàng'
    },
    home: {
      welcome: 'Chào Mừng Đến Với Zen Life Châm Cứu',
      "subtitle": "Kế thừa và đổi mới, chữa lành với sự tận tâm",
      "description1": "Trải nghiệm hiệu quả độc đáo của châm cứu thông qua sự kết hợp hoàn hảo giữa y học hiện đại và y học cổ truyền Trung Hoa.",
      "description2": "Chúng tôi kế thừa tinh hoa qua ba thế hệ, kết hợp với tư duy y học hiện đại để mang đến dịch vụ điều trị chuyên nghiệp và cá nhân hóa cho từng bệnh nhân.",
      "description3": "Đội ngũ thầy thuốc của chúng tôi không chỉ thành thạo châm cứu truyền thống, giác hơi, cạo gió và thuốc Đông y, mà còn phát triển phương pháp châm cứu độc quyền đã điều trị thành công nhiều bệnh lý phức tạp như liệt mặt, thoát vị đĩa đệm, đau thần kinh tọa và đau do chèn ép đốt sống cổ.",
      "description4": "Tại đây, bạn sẽ tìm thấy chiều sâu của y học cổ truyền cùng với hiệu quả từ quan điểm y học hiện đại. Hãy để chúng tôi giúp bạn phục hồi sức khỏe và tràn đầy sức sống!",
      subtitleinsurance: 'Bạn muốn biết bảo hiểm của mình có chi trả cho châm cứu không? ', // Translate this text
      insuranceprompt: 'Gửi câu hỏi qua tin nhắn đến số 408-922-6848 hoặc email zenlifeacu@gmail.com. Vui lòng bao gồm tên, số điện thoại, ngày sinh và ảnh hai mặt của thẻ bảo hiểm.',
      contactButton: 'Liên hệ với chúng tôi',
      bookButton: ' Đặt lịch hẹn',
      promotions: 'Khuyến Mãi và Thông Báo',
      videoTitle: "Hộp Quà Bí Ẩn Trà Thảo Mộc",
      videoDescription: "Mỗi Chủ Nhật, chúng tôi cung cấp miễn phí một loại trà thảo mộc Trung Quốc đặc biệt bí mật, chỉ có sẵn để thưởng thức trong ngày"
    },
    services: {
      title: 'Dịch Vụ Của Chúng Tôi',
      acupuncture: {
        title: 'Châm Cứu',
        description: 'Điều trị đau vai, đau đầu, đau dây thần kinh tọa, dị ứng, giảm nếp nhăn, giảm cân, mất ngủ, và nhiều hơn nữa.'
      },
      electroacupuncture: {
        title: 'Điện Châm',
        description: 'Đau mạn tính, Rối loạn thần kinh, Phục hồi chấn thương thể thao, Vấn đề cảm xúc, Vấn đề tiêu hóa, Vấn đề phụ khoa'
      },
      cupping: {
        title: 'Giác Hơi',
        description: 'Giảm đau, thoát ẩm, điều trị đau dây thần kinh tọa, thải độc, và nhiều hơn nữa.'
      },
      guaSha: {
        title: 'Cạo Gió',
        description: 'Điều trị đau bụng kinh, đau lưng, đau đầu gối và tăng cường hệ miễn dịch.'
      },
      manualTherapy: {
        title: 'Liệu Pháp Thủ Công',
        description: 'Kỹ thuật trị liệu bằng tay để giảm đau và thúc đẩy chữa lành.'
      },
      infraLight: {
        title: 'Liệu Pháp Ánh Sáng Hồng Ngoại',
        description: 'Liệu pháp ánh sáng tiên tiến để tăng cường chữa lành và giảm đau.'
      },
      herbs: {
        title: 'Thuốc Đông Y',
        description: 'Các phương thuốc cổ truyền được điều chỉnh theo nhu cầu cá nhân.'
      }
    },
    contact: {
      title: 'Liên Hệ',
      direction: 'Chỉ Đường',
      address: {
        title: 'Địa Chỉ',
        value: '8 N Abel St, Milpitas, CA 95035'
      },
      phone: {
        title: 'Điện Thoại',
        regularHours: 'Giờ Làm Việc: 408-922-6848',
        afterHours: 'Ngoài Giờ: 408-465-4289'
      },
      email: {
        title: 'Email',
        value: 'zenlifeacu@gmail.com'
      },
      payment: {
        title: 'Phương Thức Thanh Toán',
        description: 'Chúng tôi chấp nhận tất cả bảo hiểm PPO chính, thẻ tín dụng, HSA, PayPal, Venmo'
      },
      findUs: 'Chúng tôi tọa lạc tại trung tâm Milpitas, dễ dàng tiếp cận từ cả I-880 và I-680.',
      specializedClaims: "Yêu Cầu Bảo Hiểm Chuyên Biệt",
      carAccidentClaims: "Chúng tôi chấp nhận yêu cầu bảo hiểm tai nạn xe hơi và cung cấp tài liệu điều trị toàn diện cho bệnh nhân, công ty bảo hiểm và đại diện pháp lý xử lý các yêu cầu bồi thường.",
      workersCompClaims: "Chúng tôi xử lý các yêu cầu bồi thường tai nạn lao động cho các thương tích tại nơi làm việc, giúp bệnh nhân phục hồi và quay trở lại làm việc.",
      legalReferrals: "Chúng tôi hoan nghênh các giới thiệu bệnh nhân từ các công ty luật chuyên về thương tích cá nhân và các trường hợp bồi thường lao động."
    },
    // Add to existing vi.js translation object
    footer: {
      title: 'Zen Life Châm Cứu',
      address: '8 N Abel St\nMilpitas, CA 95035',
      contact: {
        title: 'Liên Hệ',
        phone: 'Điện thoại: 408-922-6848',
        email: 'Email: zenlifeacu@gmail.com'
      },
      social: {
        title: 'Kết Nối',
        wechat: 'WeChat: ZenLifeAcupuncture',
        rednote: 'RedNote: ZenLifeAcu'
      },
      copyright: 'Zen Life Châm Cứu. Đã đăng ký bản quyền.'
    },
    // ... existing code ...
    telemedicine: {
      title: "Dịch Vụ Y Tế Từ Xa",
      subtitle: "Tư vấn trực tuyến với các chuyên gia châm cứu của chúng tôi từ sự thoải mái của ngôi nhà bạn",
      benefitsTitle: "Lợi Ích Của Dịch Vụ Y Tế Từ Xa Của Chúng Tôi",
      payWithPayPal: "Thanh toán bằng PayPal", // Vietnamese
      benefits: {
        benefit1: "Tiếp cận thuận tiện với tư vấn y học Trung Quốc chuyên nghiệp mà không cần rời khỏi nhà",
        benefit2: "Đơn thuốc thảo dược được cá nhân hóa dựa trên nhu cầu sức khỏe cụ thể của bạn",
        benefit3: "Đánh giá sức khỏe chi tiết và kế hoạch điều trị tùy chỉnh",
        benefit4: "Chăm sóc theo dõi và điều chỉnh phương pháp điều trị khi cần thiết",
        benefit5: "Tiết kiệm thời gian và tránh di chuyển trong khi nhận được sự chăm sóc chuyên nghiệp",
        benefit6: "Tiếp cận kiến thức sâu rộng của chúng tôi về y học cổ truyền Trung Quốc và các phương thuốc thảo dược"
      },
      processTitle: "Cách Thức Hoạt Động Của Dịch Vụ Y Tế Từ Xa",
      process: {
        step1: {
          title: "1. Thanh Toán",
          description: "Sử dụng nút PayPal bên dưới để thanh toán cho buổi tư vấn y tế từ xa 30 phút của bạn."
        },
        step2: {
          title: "2. Đặt Lịch Hẹn",
          description: "Sau khi thanh toán, đặt lịch hẹn trực tuyến bằng số đơn hàng của bạn. Bạn sẽ có thể tải lên lịch sử y tế và bất kỳ kết quả xét nghiệm liên quan nào."
        },
        step3: {
          title: "3. Tư Vấn Trực Tuyến",
          description: "Gặp gỡ chuyên gia châm cứu của chúng tôi qua Zoom để thảo luận về tình trạng sức khỏe của bạn. Chúng tôi sẽ cung cấp đánh giá toàn diện, đơn thuốc thảo dược nếu cần và lời khuyên về sức khỏe."
        },
        step4: {
          title: "4. Thanh Toán Thuốc Thảo Dược (nếu cần)",
          description: "Nếu thuốc thảo dược được khuyến nghị, chúng tôi sẽ gửi cho bạn hóa đơn cho các loại thảo dược và chi phí vận chuyển. Thanh toán có thể được thực hiện trực tuyến."
        },
        step5: {
          title: "5. Nhận Thuốc Thảo Dược",
          description: "Chúng tôi sẽ chuẩn bị và gửi công thức thảo dược tùy chỉnh của bạn trực tiếp đến nhà bạn."
        }
      },
      paymentTitle: "Đặt Lịch Tư Vấn Y Tế Từ Xa",
      consultationFee: "Tư Vấn 30 Phút: $50",
      afterPayment: "Sau khi thanh toán, bạn sẽ nhận được email xác nhận với số đơn hàng của bạn. Sử dụng số này để đặt lịch hẹn.",
      scheduleButton: "Đặt Lịch Hẹn",
      herbsTitle: "Về Thuốc Thảo Dược Của Chúng Tôi",
      herbsDescription: "Đơn thuốc thảo dược của chúng tôi được tùy chỉnh theo nhu cầu sức khỏe cụ thể của bạn. Chúng tôi chỉ sử dụng thảo dược Trung Quốc chất lượng cao, chính hãng đã được kiểm tra về độ tinh khiết và hiệu quả.",
      shippingInfo: "Chi phí thuốc thảo dược và phí vận chuyển thay đổi tùy thuộc vào đơn thuốc và vị trí của bạn. Chúng tôi cung cấp nhiều phương thức vận chuyển khác nhau để đáp ứng nhu cầu và ngân sách của bạn."
    },
    store: {
      title: "Cửa Hàng Trực Tuyến Zen Life",
      subtitle: "Sản Phẩm Y Học Cổ Truyền Trung Hoa",
      description: "Khám phá các sản phẩm y học cổ truyền Trung Hoa chất lượng cao. Giao hàng toàn quốc.",
      buyNow: "Mua Ngay",
      products: [
        {
          name: "Kem Dưỡng Ẩm Giảm Ngứa 100% Thiên Nhiên",
          price: "$39.99",
          description: "Giúp giảm ngứa, khô da và bong tróc do chàm hoặc viêm da cơ địa. Chỉ sử dụng ngoài da.",
          image: "/images/products/product1.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/USDMG75T3T7CW"
        },
        {
          name: "Trà Thảo Dược Đa Dạng Cho Sức Khỏe",
          price: "$80",
          description: "Hỗn hợp thảo dược thủ công được điều chế đặc biệt cho các tình trạng sức khỏe khác nhau. Mỗi gói cao cấp cung cấp đủ trà trị liệu cho cả ngày, pha được tới 1 gallon nước để đạt lợi ích tối đa. Các loại thảo mộc được chọn lọc kỹ lưỡng của chúng tôi mang lại sự hỗ trợ sức khỏe tự nhiên suốt cả ngày.",
          image: "/images/products/product2.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
        }
        // More products can be added here later
      ]
    },
    // ... existing code ...
    herbtea: {
      title: "🌿 Trà Thảo Dược Trung Quốc · Đặc Biệt Pha Chế cho Kỹ Sư Vùng Vịnh 🌿",
      subtitle: "☕ Sức Khỏe Ngay Cả Trong Thời Gian Bận Rộn — Chúng Tôi Chăm Sóc Sức Khỏe Thể Chất và Tinh Thần của Bạn!",
      description: "Dựa trên thảo dược Trung Quốc tự nhiên thuần khiết và lý thuyết y học cổ truyền Trung Quốc, chúng tôi cẩn thận pha chế các loại trà sức khỏe khác nhau phù hợp với kỹ sư Vùng Vịnh. Theo thể trạng và nhu cầu khác nhau, bạn có thể linh hoạt chọn khóa trị liệu trà phù hợp với mình:",
      benefits: [
        "✔ Liều lượng được phân bổ khoa học, không cần pha thuốc",
        "✔ Túi trà để pha ngay lập tức, đơn giản và tiện lợi",
        "✔ Một khóa kéo dài ba tuần, chỉ ba tách mỗi tuần",
        "✔ Chào mừng đến cửa hàng của chúng tôi để thử miễn phí!"
      ],
      benefits1: "công dụng",
      ingredients: "Nguyên Liệu",
      customService: {
        title: "🧑‍⚕️ Dịch Vụ Tùy Chỉnh Cá Nhân Hóa · Phù Hợp Với Cơ Thể Bạn",
        description: "Chúng tôi cung cấp phân tích thể trạng Y học cổ truyền Trung Quốc một-đối-một và dịch vụ trà tùy chỉnh để tạo kế hoạch sức khỏe cá nhân hóa cho bạn:",
        options: [
          {
            name: "Trà Cá Nhân Hóa Duy Trì Sức Khỏe",
            details: "Tư vấn + Một khóa trà sức khỏe",
            price: "Chỉ $80"
          },
          {
            name: "Dịch Vụ Y Học Trung Quốc Trị Liệu",
            details: "Tư vấn + Một khóa thuốc sắc Trung Quốc cô đặc (để điều trị triệu chứng cụ thể)",
            price: "$200"
          }
        ]
      },
      popularTeas: {
        title: "🍵 Năm Loại Trà Sức Khỏe Phổ Biến Được Đề Xuất",
        teas: [
          {
            id: 1,
            name: "Trà Hoa Kim Ngân",
            ingredients: "Hoàng Kỳ, Hoa Kim Ngân, Hoa Mộc Lan, Hoa Cúc",
            benefits: "Tăng cường miễn dịch, giảm nhạy cảm mũi và dị ứng phấn hoa"
          },
          {
            id: 2,
            name: "Đồ Uống An Thần Bổ Tim",
            ingredients: "Đan Sâm, Củ Bách Hợp, Hạt Táo Chua, Thạch Xương Bồ",
            benefits: "Cải thiện chất lượng giấc ngủ, làm dịu tâm trí"
          },
          {
            id: 3,
            name: "Đồ Uống Nhân Sâm Phục Linh Bạch Truật",
            ingredients: "Vỏ Quýt, Bạch Truật, Phục Linh, Hạt Ý Dĩ, Kim Tiền Thảo, Phật Thủ",
            benefits: "Tăng cường lá lách, loại bỏ ẩm, điều hòa hệ tiêu hóa"
          },
          {
            id: 4,
            name: "Trà An Thần Tăng Trí Tuệ",
            ingredients: "Ích Trí Nhân, Kỷ Tử, Đan Sâm, Thạch Xương Bồ",
            benefits: "Cải thiện tuần hoàn não, làm tươi mới tâm trí"
          },
          {
            id: 5,
            name: "Trà Dưỡng Đẹp",
            ingredients: "Hoàng Kỳ, Đan Sâm, Đương Quy, Kỷ Tử, Hoa Hồng",
            benefits: "Bổ sung khí và huyết, làm đẹp da"
          }
        ]
      },
      pricing: {
        title: "💰 Lợi Ích Giá · Tùy Chọn Linh Hoạt",
        options: [
          "Gói thử ba tách: $15",
          "Gói cơ bản sáu tách: $26",
          "Gói khóa chín tách: $40",
          "Tùy chỉnh duy trì sức khỏe (tư vấn + trà): $80",
          "Y học Trung Quốc cô đặc trị liệu (tư vấn + thuốc sắc): $200"
        ],
        promotion: "🎁 Ghé thăm cửa hàng của chúng tôi để thử miễn phí và bắt đầu hành trình sức khỏe cá nhân hóa của bạn!"
      }
    }
  },
  electroAcupunture: {
    "header": "Điện Châm và Lợi Ích Của Nó",
    "section1_title": "Khái Niệm Cơ Bản Về Điện Châm",
    "section1_text": "Điện châm là phương pháp điều trị kết hợp giữa châm cứu truyền thống và kỹ thuật điện trị liệu hiện đại. Sau khi châm kim vào các huyệt trên cơ thể, dòng điện nhẹ được áp dụng để kích thích các huyệt. Phương pháp này được sử dụng rộng rãi trong quản lý cơn đau, các bệnh lý thần kinh, bệnh lý cơ xương khớp và cải thiện sức khỏe tổng thể.",

    "section2_title": "Lợi Ích Chính Của Điện Châm",
    "benefit1": "Giảm đau: Điện châm giúp giảm đau mạn tính và cấp tính thông qua việc điều chỉnh tín hiệu đau trong hệ thần kinh, hiệu quả trong việc điều trị các bệnh như viêm khớp, đau đầu, đau vai, v.v.",
    "benefit2": "Cải thiện lưu thông máu: Kích thích điện giúp thúc đẩy tuần hoàn máu tại chỗ, cung cấp oxy và dưỡng chất cho mô, tăng cường trao đổi chất và giảm viêm.",
    "benefit3": "Điều chỉnh hệ thần kinh: Điện châm kích thích hệ thần kinh tự động, giúp giảm lo âu, mất ngủ và tăng cường hệ miễn dịch.",
    "benefit4": "Giảm co thắt cơ và thư giãn cơ bắp: Dòng điện giúp thư giãn cơ bắp căng thẳng, cải thiện độ linh hoạt của cơ và giảm co thắt cũng như sự cứng nhắc.",
    "benefit5": "Thúc đẩy sửa chữa và phục hồi mô: Điện châm giúp tăng tốc quá trình sửa chữa mô tổn thương, thúc đẩy sự tái tạo tế bào và thường được sử dụng trong phục hồi sau chấn thương thể thao.",
    "benefit6": "Tăng cường miễn dịch: Điện châm điều chỉnh phản ứng miễn dịch của cơ thể, nâng cao khả năng chống lại nhiễm trùng và có lợi trong điều trị các bệnh mạn tính và tự miễn dịch.",

    "section3_title": "Chỉ Định Của Điện Châm",
    "indication1": "Đau mãn tính (như viêm khớp, đau lưng, đau cổ)",
    "indication2": "Rối loạn thần kinh (như phục hồi sau đột quỵ, liệt mặt)",
    "indication3": "Phục hồi chấn thương thể thao (như căng cơ, tổn thương dây chằng)",
    "indication4": "Vấn đề cảm xúc (như mất ngủ, lo âu)",
    "indication5": "Vấn đề tiêu hóa (như táo bón, tiêu chảy)",
    "indication6": "Vấn đề phụ khoa (như kinh nguyệt không đều, đau bụng kinh)",

    "section4_title": "Những Lưu Ý Khi Sử Dụng Điện Châm",
    "precaution1": "Tư vấn trước điều trị: Điện châm không phù hợp với tất cả mọi người, đặc biệt là những người có bệnh tim, vấn đề da liễu hoặc phụ nữ mang thai. Trước khi sử dụng, hãy tham khảo ý kiến của bác sĩ chuyên môn.",
    "precaution2": "Trong quá trình điều trị, một số người có thể cảm thấy một chút tê hoặc cảm giác điện. Nếu có cảm giác không thoải mái, hãy thông báo cho bác sĩ để điều chỉnh cường độ.",
    "precaution3": "Tránh sử dụng quá mức: Mặc dù điện châm hiệu quả, nhưng việc sử dụng thường xuyên hoặc cường độ quá mạnh có thể gây ảnh hưởng xấu đến da và mô."
  }
};